import {
  Box,
  Button,
  ButtonGroup,
  Editable,
  EditableInput,
  EditablePreview,
  EditableTextarea,
  Flex,
  IconButton,
  useBoolean,
  useEditableControls,
} from '@chakra-ui/react'
import { useState } from 'react'

import type { IFAQ } from '../../data/faq'
import { Close, EditFilled, Plus } from '../../icons'

const EditableControls = () => {
  const { isEditing, getCancelButtonProps, getEditButtonProps } = useEditableControls()
  const iconSize = 4

  return isEditing ? (
    <ButtonGroup justifyContent="start">
      <Button variant="outline" colorScheme="yellow" aria-label="Zrušit" {...getCancelButtonProps()}>
        <Close width={iconSize} height={iconSize} />
        Zrušit úpravy
      </Button>
    </ButtonGroup>
  ) : (
    <Flex justifyContent="start">
      <Button variant="outline" sx={{ py: 2 }} {...getEditButtonProps()}>
        <EditFilled color="gray.500" width={iconSize} height={iconSize} />
        Upravit odpověď
      </Button>
    </Flex>
  )
}

export const FAQAdminItem = ({ item }: { item?: IFAQ }) => {
  const emptyItem: IFAQ = {
    id: 0,
    question: '',
    answer: '',
  }
  const [isOpen, setOpen] = useBoolean()
  const [faq, setFaq] = useState<IFAQ>(item || emptyItem)

  return (
    <Box sx={{ display: 'grid', p: 4, gap: 4, bg: 'white', borderRadius: 'md', boxShadow: 'card' }}>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          placeContent: 'start',
          placeItems: 'center',
        }}
      >
        <IconButton aria-label="Upravit novinku" variant="ghost" onClick={setOpen.toggle}>
          <Plus color="secondary.500" />
        </IconButton>

        <Editable
          sx={{ w: '100%' }}
          defaultValue={faq.question}
          placeholder="Napište text otázky"
          onSubmit={(nextValue) => setFaq({ ...faq, question: nextValue })}
        >
          <EditablePreview sx={{ fontWeight: 'semibold' }} />
          <EditableInput sx={{ w: '100%' }} />
        </Editable>
      </Box>

      {isOpen && (
        <Box sx={{ pl: 7, pb: 4 }}>
          <Editable
            sx={{ w: '100%', display: 'grid', gap: 2 }}
            defaultValue={faq.answer}
            placeholder={emptyItem.answer}
            onSubmit={(nextValue) => {
              console.log(nextValue)

              if (nextValue.trim() === '') {
                console.log(emptyItem.answer)

                setFaq({ ...faq, answer: emptyItem.answer })
              } else {
                setFaq({ ...faq, answer: nextValue })
              }
            }}
          >
            <EditablePreview />
            <EditableTextarea rows={10} sx={{ w: '100%' }} />
            <EditableControls />
          </Editable>
        </Box>
      )}
    </Box>
  )
}
